import { FC, useMemo } from 'react';

import classNames from 'classnames';

import './ContentListItem.scss';

import { TestMetadata } from '../types';

export interface ContentListItemProps {
  /** Class name for Content List Item*/
  className?: string;
  /** Determines if the list item is an interactive object*/
  isInteractive?: boolean;
  /** Can list item be re-ordered */
  isReorderable?: boolean;
  /**  Shows reorderable disabled, useful for edit mode */
  isReorderableDisabled?: boolean;
  // Test IDs for component sections
  testMetadata?: {
    contentListItem?: TestMetadata;
    reorderable?: TestMetadata;
    reorderableIcon?: TestMetadata;
    content?: TestMetadata;
  };
}

const ContentListItem: FC<ContentListItemProps> = ({
  children,
  className,
  isInteractive = false,
  isReorderable = false,
  isReorderableDisabled = false,
  testMetadata = {
    reorderable: { 'data-testid': 'sb-content-list__reorderable' },
    reorderableIcon: { 'data-testid': 'sb-content-list__reorderable_icon' },
    content: { 'data-testid': 'sb-content-list__content' },
  },
  ...otherProps
}) => {
  const contentListItemClassNames = useMemo(
    () =>
      classNames('sb-content-list-item', className, {
        'sb-content-list-item__interactive': isInteractive,
      }),
    [className, isInteractive],
  );

  return (
    <li
      {...otherProps}
      className={classNames(contentListItemClassNames)}
      {...testMetadata?.contentListItem}
    >
      {isReorderable && (
        <div
          className={classNames('sb-content-list-item__reorder', {
            'sb-content-list-item__reorder-disabled': isReorderableDisabled,
          })}
          {...testMetadata?.reorderable}
        >
          <i
            className={classNames(
              'fas fa-grip-vertical',
              'sb-content-list-item__reorder-icon',
              {
                'sb-content-list-item__reorder-icon-disabled':
                  isReorderableDisabled,
              },
            )}
            {...testMetadata?.reorderableIcon}
          />
        </div>
      )}
      <div className="sb-content-list-item__content" {...testMetadata?.content}>
        {children}
      </div>
    </li>
  );
};

export default ContentListItem;
